import {
  $get,
  $post,
  $request,
} from '@/utils/request';

import servers from '../servers';

/**
 * @description: 千丁 - 登录获取验证码
 */
export const getVerificationCodeRequest = () => $post(`${servers.base}/api/v1/user/verificationCode`);

/**
 * @description: 千丁 - 登录接口
 */
export const loginRequest = (data = {}) => $post(`${servers.base}/api/v1/user/login`, data);

/**
 * @description: 获取用户权限信息，千丁账户
 */
export const getUserMenusRequest = (data = {}) => $post(`${servers.backend}/auth/getUserMenu`, data);

/**
 * @description: 获取用户权限信息，龙湖账户
 */
export const getLfUserMenusRequest = () => $get(`${servers.base}/api/v1/user/info`);

/**
 * @description: 退出登录接口
 */
export const logout = () => $request({
  url: `${servers.base}/api/v1/user/logout`,
  method: 'get',
});

/**
 * @description: 项目树
 * YApi： https://apidock.longhu.net/project/7143/interface/api/890345
 */
export function getAreaTree(channel: any) {
  return $request({
    url: `${servers.backend}/v1/auth/tree`,
    method: 'get',
    headers: {
      channel,
    },
  });
}
